const verifyOrganisation = 'VERIFY_ORGANISATION';
const authorizedToSign = 'AUTHORIZED_TO_SIGN';

export default {
  verifyOrganisation,
  authorizedToSign,
};
